<template>
  <!-- eslint-disable -->
  <v-container>
    <v-dialog
      width="1000"
      persistent
      v-model="this.$store.state.modalEmailRecibido"
    >
      <v-card>
        <v-container class="d-flex flex-columns">
          <div>
            <v-btn
              color="#2250b3"
              icon
              class="mt-2"
              @click="$store.commit('setEmailRecibido', false)"
            >
              <v-icon size="30"> mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="ml-5">
            <p
              style="color: #2250b3"
              class="mt-3 subtitle-1 font-weight-regular"
            >
              VideoEmails Recibidos
            </p>
          </div>

          <div class="mx-auto">
            <v-text-field label="Buscar VideoEmail" class="rounded-lg" outlined>
            </v-text-field>
          </div>
        </v-container>
        <v-divider></v-divider>

        <v-data-table
          :headers="headers"
          :items="list"
          disable-sort
          :items-per-page="5"
        >
          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | toDate }} {{ item.created_at | toHour }}
          </template>
          <template v-slot:[`item.name`]="{ item }">
            {{ item.client.name }}
          </template>
          <template v-slot:[`item.email`]="{ item }">
            {{ item.client.email }}
          </template>
          <!-- <template v-slot:[`item.tipoAtencion`]="{ item }">
					Videollamadas
				</template> -->
          <template v-slot:[`item.phone_number`]="{ item }">
            {{ item.client.phone_number }}
          </template>
          <template v-slot:[`item.id`]="{ item }">
            <v-btn
              color="#2250b3"
              class="ml-n2"
              elevation="1"
              outlined
              icon
              @click="irVideoEmail(item)"
            >
              <v-icon>mdi-email-fast</v-icon>
            </v-btn>
          </template>
          <template> </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import {
  registroUser,
  getVideoCall,
  getListVideoEmail,
} from "../../../helpers/api/calls";
export default {
  props: {
    id: {
      type: Number,
    },
  },
  filters: {
    toDate: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
    toHour: function (date) {
      if (!date) {
        return "-";
      }
      return moment(date).format("HH:mm A");
    },
  },
  data() {
    return {
      info: [],
      list: [],

      headers: [
        {
          text: "Fecha y Hora",
          value: "created_at",
        },

        { text: "Nombre", value: "name" },
        { text: "Email", value: "email" },
        { text: "Telefono", value: "phone_number" },
        { text: "Ver", value: "id" },
      ],
    };
  },
  watch: {
    id(newValue) {
      // console.log(newValue);
      if (this.id || newValue) {
        this.registroUser();
      }

      // console.log('Funcionando');
    },
  },
  mounted() {
    // console.log(this.dateId);
    this.getVideoCall();
    this.getListVideoEmail();
    length;
  },
  methods: {
    irVideoEmail(item) {
      console.log(item);
      this.$router.push({ name: "VideoEmail", query: { id: item.id } });
      // console.log("Redireccionar");
    },

    async getVideoCall() {
      const info = await getVideoCall();
      this.info = info.data;

      // console.log("Inforemacion tabla",this.info);
    },
    async getListVideoEmail() {
      const list = await getListVideoEmail();
      this.list = list.data;
      this.$store.commit("setCountRecibidoMes", list.data.length);
      // console.log("Listado", this.list);
    },
  },
};
</script>

<style></style>
